import T from 'utils/T';
import ex from 'utils/ex';
import './Division.css';
// 디자인적인 분리 - 대영역
// 소영역은 Segment
export default function Division(props) {
  const {
    full,
    direction,
    ...rest
  } = props || {};
  return (
    <div {...ex(['Division', direction, { full }], rest)}>
    </div>
  );
}
